import React from 'react';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';
import { PlayerProfilePreview } from '../..';

import './PlayerTooltip.scss';

const PlayerTooltip = ({ playerDetails, uniqueId })=> {
  const { avatar,lastName, firstName, playerNumber } = playerDetails
  return (
    <ReactTooltip id={`player-${uniqueId}`} className='customTheme'>
      <div className='player-tooltip'>
        <PlayerProfilePreview
          avatar={avatar}
          firstName={firstName}
          lastName={lastName}
          playerNumber={playerNumber}
          hasDetails={false}
        />
      </div>
    </ReactTooltip>
  );
};

PlayerTooltip.propTypes = {
  playerDetails: PropTypes.object,
  uniqueId: PropTypes.string
};

PlayerTooltip.defaultProps = {
  playerDetails: {},
  uniqueId: ''
};

export default PlayerTooltip;
